import * as React from 'react';
import { increment, decrement } from '../logic/util/DateTime';
interface Props {
  date: string;
  operateMonth: Function;
}

const month = (props: Props) => {
  const marginLeft = {
    marginLeft: '20px'
  };
  return (
    <div className="level-item has-text-centered">
      <p className="title">{props.date}</p>
      <nav className="pagination is-small" style={marginLeft}>
        <button
          className="pagination-previous"
          onClick={e => props.operateMonth(decrement)}
        >
          <span className="icon">
            <i className="fas fa-angle-double-left" />
          </span>
          Previous
        </button>
        <button className="pagination-link" onClick={e => props.operateMonth()}>
          <span className="icon">
            <i className="far fa-calendar-alt" />
          </span>
          thisMonth
        </button>
        <button
          className="pagination-next"
          onClick={e => props.operateMonth(increment)}
        >
          Next
          <span className="icon">
            <i className="fas fa-angle-double-right" />
          </span>
        </button>
      </nav>
    </div>
  );
};

export default month;



// WEBPACK FOOTER //
// ./src/components/Month.tsx